import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {CellComponent} from '@shared/components/cell-components/cell-component';
import {FieldDefinition} from '@shared/models/field-definition';
import {Subject} from 'rxjs';
import {PlatformCommand} from '@shared/commands/command-base';
import {Api} from '@shared/constants/common-field.constants';
import {CommandService} from '@core/services/command.service';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {take} from 'rxjs/operators';
import {SnackBarService} from '@core/services/snack-bar.service';

@Component({
    standalone: false,
    selector: 'app-map-company-cell-viewer',
  templateUrl: './map-company-cell-viewer.component.html',
  styleUrls: ['./map-company-cell-viewer.component.scss']
})
export class MapCompanyCellViewerComponent implements OnInit, CellComponent {
  fieldDefinition: FieldDefinition;
  invalidateSubject: InvalidateSubject;
  item: any;
  roles: any;
  @Output() valueChanged: EventEmitter<any> = new EventEmitter();
  ngUnsubscribe$: Subject<void> = new Subject<void>();
  constructor(private commandService: CommandService,
              private snackBarService: SnackBarService) { }

  ngOnInit() {

  }

  deleteCompanyFromMerge(mergeCompanyId: string, companyId: string) {
    const deleteCompanyFromMergeCommand = new PlatformCommand('DeleteCompanyFromMergeLicenseCommand', Api.AdminPanel);
    deleteCompanyFromMergeCommand.fieldValues['MergeLicenseId'] = mergeCompanyId;
    deleteCompanyFromMergeCommand.fieldValues['DeleteCompanyId'] = companyId;
    this.commandService.executePlatformCommand(deleteCompanyFromMergeCommand).pipe(take(1)).subscribe(commandResponse => {
      if (commandResponse.fieldValues['SnackBarErrorMessage']) {
        this.snackBarService.showError(commandResponse.fieldValues['SnackBarErrorMessage']);
      }
      this.invalidateSubject.invalidate();
    }, err => {
      this.snackBarService.showError(err.fieldValues['SnackBarMessage']);
    });
  }

  addCompanyInMerge(mergeCompanyId: string) {
    const addCompanyInMappingCommand = new PlatformCommand('AddCompanyInMergeCommand', Api.AdminPanel);
    addCompanyInMappingCommand.fieldValues['MergeLicenseId'] = mergeCompanyId;
    this.commandService.executePlatformCommand(addCompanyInMappingCommand).pipe(take(1)).subscribe(commandResponse => {
      this.invalidateSubject.invalidate();
    }, err => {
      this.snackBarService.showError(err);
    });
  }
}
